// extracted by mini-css-extract-plugin
module.exports = {"list_content":"AboutUsGlobal_list_content__AdIoM"};